import { IxProgress } from './IxProgress.js';

window.customElements.define('ix-progress', IxProgress);
